import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

type StorefrontIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const StorefrontIcon: React.FC<StorefrontIconProps> = ({
  title = 'Storefront',
  viewBox = '0 0 24 24',
  ...props
}) => (
  <CreateIconComponent viewBox={viewBox} title={title} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.58812 3.02981H12H14.4119V8.63395C13.4013 9.37871 12.4169 9.49046 11.554 9.34605C10.8216 9.22347 10.1387 8.90639 9.58812 8.54489V3.02981ZM8.18078 10.4102C7.02899 11.1699 5.89097 11.4673 4.83333 11.4311V20.8333H7.16667V14C7.16667 13.3556 7.689 12.8333 8.33333 12.8333H15.6667C16.311 12.8333 16.8333 13.3556 16.8333 14V20.8333H19.1667V11.4311C18.1275 11.4666 17.0108 11.1802 15.8797 10.4496C14.3272 11.629 12.6707 11.8987 11.1689 11.6474C10.0121 11.4538 8.98475 10.96 8.18078 10.4102ZM14.5 20.8333V15.1666H9.5V20.8333H14.5ZM0.941441 9.47775C1.29388 9.9162 1.82372 10.3981 2.5 10.774V22C2.5 22.6443 3.02233 23.1666 3.66667 23.1666H20.3333C20.9777 23.1666 21.5 22.6443 21.5 22V10.774C22.1763 10.3981 22.7061 9.9162 23.0586 9.47775C23.3448 9.12168 23.3968 8.63131 23.1918 8.22309L19.7335 1.3394C19.5355 0.945247 19.1321 0.696472 18.691 0.696472H15.5786H12H8.42146H5.30902C4.86792 0.696472 4.46454 0.945247 4.26652 1.3394L0.808257 8.22309C0.603171 8.63131 0.655224 9.12168 0.941441 9.47775ZM7.25479 3.02981V8.20496C6.13715 9.07555 5.21392 9.17806 4.54187 9.06042C4.04663 8.97373 3.61348 8.75387 3.27785 8.50504L6.02852 3.02981H7.25479ZM16.7452 3.02981V8.20496C17.8629 9.07555 18.7861 9.17806 19.4581 9.06042C19.9534 8.97373 20.3865 8.75387 20.7222 8.50504L17.9715 3.02981H16.7452Z"
      // fill="#505050"
    />
  </CreateIconComponent>
);

export default StorefrontIcon;
